<template>
<div class="schulte-out">
  <div class="schulte-cont">
    <div class="square" :style="squareStyle">
      <div
        v-for="(item, index) in circles"
        :key="index"
        class="circle"
        :class="{'done': item.done, 'wrong': item.wrong}"
        :style="circleStyle(item)"
        @click="onCircle(item)"
      >{{ item.num }}</div>
    </div>
    <div class="info">
      <span>下一个数字：{{ nextNum > max ? '完成' : nextNum }}</span>
      <span>用时：{{ formatTime(time) }}</span>
      <button class="btn" @click="start">{{ running ? '重新开始' : '开始' }}</button>
    </div>
    <score-modal
      :visible="showResult"
      :time="time"
      :records="latest5"
      :percentile="resultPercentile"
      :first="resultFirst"
      :title="modeName"
      @close="closeResult"
    />
  </div>
</div>
</template>

<script>
import schulteMixin from './schulteMixin'
export default {
  name: 'schulte-circle',
  mixins: [schulteMixin],
  data () {
    return {
      modeKey: '7x7-circle',
      modeName: '7×7 圆形',
      max: 49,
      circles: [],
      nextNum: 1,
      startTime: 0,
      time: 0,
      running: false,
      timer: null,
      maxSide: 600,        // 宽屏时的正方形边长
      padding: 16,
      boxW: 600,           // 当前容器宽（窄屏缩小）
      boxH: 600,           // 当前容器高（窄屏拉高成矩形）
      rzTimer: null
    }
  },
  computed: {
    squareStyle () {
      return {
        width: this.boxW + 'px',
        height: this.boxH + 'px',
        padding: this.padding + 'px',
        boxSizing: 'border-box'
      }
    }
  },
  mounted () {
    this.reset()
    window.addEventListener('resize', this.onResize)
    window.addEventListener('orientationchange', this.onResize)
  },
  beforeDestroy () {
    clearInterval(this.timer)
    clearTimeout(this.rzTimer)
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('orientationchange', this.onResize)
  },
  methods: {
    reset () {
      // 1-49 数字
      const nums = []
      for (let i = 1; i <= this.max; i++) nums.push(i)
      this.shuffle(nums)
      // 给每个数字随机分配一个基准半径（大小不一）
      const radiusPool = [20, 22, 25, 28, 31, 34, 37]
      this.circles = nums.map(n => {
        const baseR = radiusPool[Math.floor(Math.random() * radiusPool.length)]
        return { num: n, baseR, r: baseR, x: 0, y: 0, done: false, wrong: false }
      })
      this.placeAll()
      this.nextNum = 1
      this.time = 0
      this.running = false
      clearInterval(this.timer)
    },
    /**
     * 依据视口计算容器宽高：
     * 宽屏 → 正方形；窄屏（手机）→ 按宽适配、并拉高成矩形以保留排布面积
     */
    updateBox () {
      const margin = 16
      const vw = window.innerWidth
      const vh = window.innerHeight
      const fitW = vw - margin
      const isNarrow = fitW < this.maxSide
      const boxW = Math.max(260, Math.min(this.maxSide, fitW))
      // 保持与正方形相近的面积，窄屏时拉高为矩形
      const areaH = (this.maxSide * this.maxSide) / boxW
      // 留出标题/标签/信息栏的高度
      const cap = Math.max(300, vh - 170)
      let boxH
      if (isNarrow) {
        boxH = Math.max(boxW, Math.min(areaH, cap))
      } else {
        boxH = this.maxSide
      }
      this.boxW = boxW
      this.boxH = boxH
    },
    /**
     * 排布所有圆形（保留 num/done/wrong/baseR，仅重算 x/y/r）
     */
    placeAll () {
      this.updateBox()
      const innerW = this.boxW - this.padding * 2
      const innerH = this.boxH - this.padding * 2
      const items = this.circles.slice().sort((a, b) => b.baseR - a.baseR)
      const placed = []
      for (const it of items) {
        let ok = false
        let r = it.baseR
        // 尝试若干次随机放置；放不下则缩小半径重试
        for (let shrink = 0; shrink < 6 && !ok; shrink++) {
          const tries = 600
          for (let t = 0; t < tries; t++) {
            const x = r + Math.random() * Math.max(0, innerW - 2 * r)
            const y = r + Math.random() * Math.max(0, innerH - 2 * r)
            let overlap = false
            for (const p of placed) {
              const dx = x - p.x
              const dy = y - p.y
              const dist = Math.sqrt(dx * dx + dy * dy)
              if (dist < r + p.r + 4) {
                overlap = true
                break
              }
            }
            if (!overlap) {
              it.x = x
              it.y = y
              it.r = r
              placed.push(it)
              ok = true
              break
            }
          }
          if (!ok) r = Math.max(14, r - 3)
        }
        // 极端情况下放不下，强行随机放一个，避免卡死
        if (!ok) {
          it.r = Math.min(it.baseR, Math.max(14, Math.min(innerW, innerH) / 5))
          it.x = it.r + Math.random() * Math.max(0, innerW - 2 * it.r)
          it.y = it.r + Math.random() * Math.max(0, innerH - 2 * it.r)
          placed.push(it)
        }
      }
      // 触发响应式更新
      this.circles = this.circles.slice()
    },
    onResize () {
      clearTimeout(this.rzTimer)
      this.rzTimer = setTimeout(() => {
        this.placeAll()
      }, 200)
    },
    start () {
      this.reset()
      this.running = true
      this.startTime = Date.now()
      this.timer = setInterval(() => {
        this.time = (Date.now() - this.startTime) / 1000
      }, 100)
    },
    onCircle (item) {
      if (!this.running) return
      if (item.num === this.nextNum) {
        item.done = true
        this.nextNum++
        if (this.nextNum > this.max) {
          clearInterval(this.timer)
          this.running = false
          this.time = (Date.now() - this.startTime) / 1000
          this.schulteFinish()
        }
      } else {
        item.wrong = true
        setTimeout(() => { item.wrong = false }, 300)
      }
    },
    circleStyle (item) {
      const d = item.r * 2
      return {
        width: d + 'px',
        height: d + 'px',
        left: item.x + this.padding - item.r + 'px',
        top: item.y + this.padding - item.r + 'px',
        fontSize: Math.max(12, item.r * 0.7) + 'px'
      }
    },
    shuffle (arr) {
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        const tmp = arr[i]
        arr[i] = arr[j]
        arr[j] = tmp
      }
    },
    formatTime (t) {
      return t.toFixed(1) + ' s'
    }
  }
}
</script>

<style lang="scss" scoped>
.schulte-out{
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.schulte-cont{
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 10px 40px;
  box-sizing: border-box;
}
.square{
  position: relative;
  background-color: #f5f5f5;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  max-width: 96vw;
}
.circle{
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-weight: bold;
  color: #333;
  background-color: #fff;
  border: 1px solid #ddd;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  transition: background-color 0.15s, color 0.15s, transform 0.1s;
  &:active{
    background-color: #e3f2fd;
  }
  &.done{
    background-color: #4caf50;
    color: #fff;
    border-color: #4caf50;
  }
  &.wrong{
    background-color: #ff5252;
    color: #fff;
    border-color: #ff5252;
    transform: scale(0.96);
  }
}
.info{
  margin-top: 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: #{'clamp(13px, 3.6vw, 16px)'};
  color: #333;
  flex-wrap: wrap;
  justify-content: center;
}
.btn{
  padding: 8px 18px;
  font-size: 14px;
  background-color: #2196f3;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:active{
    background-color: #1e88e5;
  }
}
</style>
